import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersTwo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayersTwo"><Path d="M4.44087 13.2322L1 15.1438L12.0591 21.2878L23.1183 15.1438L19.6183 13.1994L12 17.4318L4.44087 13.2322Z" fill="currentColor"/><Path d="M12.0005 2.85596L0.941406 8.99992L12.0005 15.1439L23.0597 8.99992L12.0005 2.85596Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayersTwo;
